import { defineComponent } from 'vue';
import { useRegisterTestStore } from '@/store/RegisterTestStore';
import ThemesHelper from '@/helpers/ThemesHelper';
import BaseFooter from '@/components/Shared/BaseFooter/BaseFooter.vue';
import BaseNavigation from '@/components/BaseNavigation/BaseNavigation.vue';
import TestInstructionsStepOne from '@/components/Shared/RegisterTest/TestInstructionsStepOne/TestInstructionsStepOne.vue';
import TestInstructionsStepTwo from '@/components/Shared/RegisterTest/TestInstructionsStepTwo/TestInstructionsStepTwo.vue';
import TestInstructionsStepThree from '@/components/Shared/RegisterTest/TestInstructionsStepThree/TestInstructionsStepThree.vue';
import ResultTest from '@/components/RegisterTest/ResultTest/ResultTest.vue';
import ResultPicture from '@/components/RegisterTest/ResultPicture/ResultPicture.vue';
import CheckSymptoms from '@/components/RegisterTest/CheckSymptoms/CheckSymptoms.vue';
import BasicPersonalData from '@/components/RegisterTest/BasicPersonalData/BasicPersonalData.vue';
import PersonalData from '@/components/RegisterTest/PersonalData/PersonalData.vue';
import axios from 'axios';
import GoogleAnalyticsEvents from '@/helpers/GoogleAnalyticsEvents';
import LoadingScreen from '@/components/Shared/LoaderScreen/LoaderScreen.vue';
import { mapWritableState } from 'pinia';

export default defineComponent({
  components: {
    BaseFooter,
    BaseNavigation,
    TestInstructionsStepOne,
    TestInstructionsStepTwo,
    TestInstructionsStepThree,
    ResultTest,
    ResultPicture,
    CheckSymptoms,
    BasicPersonalData,
    PersonalData,
    LoadingScreen,
  },
  computed: {
    ...mapWritableState(useRegisterTestStore, ['registerTestId']),
    getActiveStep(): number {
      return this.activeStep;
    },
  },
  data() {
    return {
      activeStep: 1,
      hideFooter: false,
      registerTestStore: useRegisterTestStore(),
      Loader: false,
    };
  },
  mounted() {
    this.registerTestStore.$reset();
    this.registerTestStore.canJumpNext = true;
  },
  methods: {
    nextStep() {
      let currentStep = this.activeStep;
      if (
        this.registerTestStore.canJumpNext ||
        this.registerTestStore.canJumpNext == undefined
      ) {
        this.registerTestStore.canJumpNext = true;
        this.hideFooter = true;
        currentStep++;
        GoogleAnalyticsEvents.switchStepEvent(currentStep);

        if (currentStep == 9) {
          this.Loader = true;
          this.hideFooter = true;
          setTimeout(() => {
            this.Loader = true;
            this.hideFooter = true;
            currentStep--;
            this.saveTest();
          }, 3000);
        } else {
          const stepEl: any = this.$refs[`step-${currentStep}`];
          const numPreviousStep = currentStep - 1;
          const previousStepEl: any = this.$refs[`step-${numPreviousStep}`];
          previousStepEl.setAnimationType('setNextDismissAnimation');
          this.registerTestStore.canJumpNext = stepEl.isValidStep();
          setTimeout(() => {
            stepEl.setAnimationType('setNextShowAnimation');
          }, 150);
        }
      } else {
        const stepEl: any = this.$refs[`step-${currentStep}`];
        stepEl.errorValidation();
      }
      setTimeout(() => {
        this.activeStep = currentStep;
      }, 300);
      setTimeout(() => {
        this.hideFooter = false;
      }, 550);
    },
    previousStep() {
      let currentStep = this.activeStep;
      currentStep--;

      if (currentStep == 0) {
        this.$router.push({ name: 'HomeCovid' });
      } else {
        this.hideFooter = true;
        const stepEl: any = this.$refs[`step-${currentStep}`];
        this.registerTestStore.canJumpNext =
          currentStep == 1 ? true : stepEl.isValidStep();
        const numPreviousStep = currentStep + 1;
        const nextStepEl: any = this.$refs[`step-${numPreviousStep}`];
        nextStepEl.setAnimationType('setPreviousDismissAnimation');
        setTimeout(() => {
          const stepEl: any = this.$refs[`step-${currentStep}`];
          stepEl.setAnimationType('setPreviousShowAnimation');
        }, 150);
      }

      setTimeout(() => {
        this.activeStep = currentStep;
      }, 300);
      setTimeout(() => {
        this.hideFooter = false;
      }, 550);
    },
    saveTest() {
      const data = this.formatPostData();

      const url = process.env.VUE_APP_API_HOST;

      axios
        .post(`${url}/rapid-test/covid`, data, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((res) => {
          this.registerTestId = res.data.rapidTest.id;
        })
        .catch((error) => {
          // TODO - handle this error
          console.error(error);
        })
        .finally(() => {
          GoogleAnalyticsEvents.generateCardResult();
          this.$router.push({ name: 'ViewResultCard' });
        });
    },
    formatPostData() {
      const numberPattern = /\d+/g;
      const tmpPatient = { ...this.registerTestStore.patient };
      tmpPatient.phone = tmpPatient.phone
        ?.match(numberPattern)
        ?.join('') as string;
      tmpPatient.document = tmpPatient.document
        ?.match(numberPattern)
        ?.join('') as string;

      const splitBirthdate = tmpPatient.birthdate.split('/');
      tmpPatient.birthdate = `${splitBirthdate[2]}-${splitBirthdate[1]}-${splitBirthdate[0]}`;
      tmpPatient.emailMkt = true;
      return {
        rapidTest: {
          manufacturer: ThemesHelper.getThemeParams('manufacturer'),
          product: ThemesHelper.getThemeParams('testName'),
        },
        patient: tmpPatient,
        rapidTestResult: {
          code: '123456', // todo - pass correct value
          result: this.registerTestStore.resultTest == 'positive',
        },
        rapidTestSymptom: {
          symptom: '123456', // todo - pass correct value
          result: this.registerTestStore.testSymptoms == 'yes',
        },
      };
    },
  },
});
